module.exports = __webpack_public_path__ + "static/media/34303_1528520779687_817726_n.cbec1640.jpg";